module.exports = __webpack_public_path__ + "img/hypergraph-min.17b83ea2.png";